/* c_staff-mode-color.js — 客注モード header bar color decision (spec §2.1.7).
 * Pure, DOM-free unit so the latch/OR logic is unit-testable.
 * Loaded before c_staff-mode-header-bar.js; exposes window.CStaffModeColor.
 */
(function () {
  'use strict';

  // Decide the header bar color from { dirty, member, cartCount } (spec §2.1.7).
  //   red = dirty || member || cartCount > 0   ;   clearEnabled === red
  // LATCH CONTRACT — the caller MUST pass the PERSISTED `dirty` flag (read from the
  // staff_mode_needs_clear cookie), never derive it from member/cart. That flag is what
  // keeps the bar red after a cart is emptied or a member logs out mid-session: cartCount
  // can drop to 0 here and the bar stays red solely because `dirty` is still true. Only
  // the clear button / logout / 401 clear the flag (and thus return blue).
  // `member` and `cartCount > 0` are defensive OR terms so a failed flag write still shows
  // red from the current state.
  function computeBarState(input) {
    var dirty = !!(input && input.dirty);
    var member = !!(input && input.member);
    var cartCount = Number((input && input.cartCount) || 0);
    var red = dirty || member || cartCount > 0;
    return { red: red, clearEnabled: red };
  }

  // Read live inputs off the bar DOM root + the persisted dirty flag (DI via deps.getDirty,
  // so this stays DOM/cookie-agnostic and unit-testable), decide color, and apply it:
  // toggles the --needs-clear class and the clear button's disabled state. Returns the
  // computed state so callers (event handlers) can branch on it.
  function recomputeBarColor(root, deps) {
    if (!root) return computeBarState({});
    var ds = root.dataset || {};
    var member = ds.customerLoggedIn === 'true';
    var dirty = (deps && deps.getDirty) ? !!deps.getDirty() : false;
    var state = computeBarState({ dirty: dirty, member: member, cartCount: ds.cartItemCount });
    if (root.classList) root.classList.toggle('c_staff-mode-header-bar--needs-clear', state.red);
    if (deps && deps.clearButton) deps.clearButton.disabled = !state.clearEnabled;
    return state;
  }

  // Reduce a cart-change event's payload (item_count read off detail.cart by the caller) into the
  // two decisions the header-bar wiring needs (spec §2.1.7, guest-latch extension):
  //   - itemCount: the count to persist to the bar's dataset, or null when the event carried no
  //     cart payload (→ caller leaves the dataset untouched).
  //   - armLatch: true iff items are present (count > 0) → the caller arms the dirty latch.
  // Latch policy: ANY cart event that sees items arms the latch, so the bar stays red even after
  // the cart is later emptied — until the clear button / logout / 401 clears the flag. An empty
  // cart (count 0) does NOT arm, and a payload-less event (the clear button's own cart:refresh,
  // dispatched without detail.cart) neither arms nor updates the count — that is what keeps the
  // clear flow from re-arming the latch it just cleared.
  function reduceCartEvent(input) {
    var raw = input ? input.itemCount : undefined;
    var hasCount = raw !== undefined && raw !== null && raw !== '' && !isNaN(Number(raw));
    var count = hasCount ? Number(raw) : null;
    return { itemCount: count, armLatch: hasCount && count > 0 };
  }

  window.CStaffModeColor = {
    computeBarState: computeBarState,
    recomputeBarColor: recomputeBarColor,
    reduceCartEvent: reduceCartEvent,
  };
})();
